<template>
  <div >
    <v-col cols="3" class="d-flex justify-begin mb-2">
            <v-btn class="mx-2 gris_medio" @click="exportToCSV">
            <span class="material-symbols-outlined">arrow_outward</span>   {{$t('general.exportar')}}
            </v-btn>
        </v-col>
        <div class="contenedor-tabla">
         <div class="scroll-container"   >
          <table>
             <!--  <caption class="table-header">{{ this.$t('electricidad.precios_omie') }}</caption> -->
              <thead>
                <tr>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.horizonte') }}</th>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.hora') }}</th>
                  <th class="encabezado_bold" >{{ this.$t('electricidad.precio_omie_fmt') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(registro, index) in precios_omie" :key="index" class="tabla-hover">
                  <td class="primera_columna">{{ registro.fecha_hora }}</td>
                  <td class="primera_columna" style="text-align: center !important;">{{registro.hora}}</td>
                  <td>
                    {{ (registro.valor !== null && registro.valor !== undefined) 
                          ? Number(registro.valor).toLocaleString('es-ES', { minimumFractionDigits: 2 }) 
                          : "" 
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
  </div>
</template>

<script>
//imports
export default {
    props:{
        precios_omie:{
            type:Array,
            required:true,
        },
        horizonte:{
          type: Number,
          required: true
        },
        horizonte_horas:{
          type:Number,
          required:true,
          
        }
    },

    data(){
        return{

             showAlert:false,
            hoursList:[],
            preciosOmie :[...this.precios_omie],
           
                columns:[
                { name: "Horizonte", prop: "fecha_hora", size: 150, readonly:true },
                { name: "Hora", prop: "hora", size: 150, readonly:true },
                { name: "Precio casación OMIE (€/MWh)", prop: "valor", size: 150,readonly:true},

                
                    ],
        };
      },

    created(){
        //this.crearColumnas(7);
      
    },
    
    methods:{
       toCsvDecimalComma(v, fixed = null) {
          if (v === null || v === undefined || v === '') return '';
          const n = Number(v);
          if (Number.isNaN(n)) return '';
          const s = fixed != null ? n.toFixed(fixed) : String(n);
          return s.replace('.', ',');
        },
      exportToCSV() {
            const headers = this.columns.map((col) => col.name).join(";");

            const rows = (this.precios_omie || []).slice(0, this.horizonte_horas).map((row) =>
            this.columns.map((col) => {
              const val = row[col.prop];
              if (val === undefined || val === null) return "";
              return col.prop === "valor" ? this.toCsvDecimalComma(val, 2) : String(val);
            }).join(";")
          );

            const csvContent = [headers, ...rows].join("\n");
            const BOM = "\uFEFF";
            const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "precios_OMIE.csv";
            a.click();
            URL.revokeObjectURL(url);
          },
        
    },
}

</script>
<style scoped>
.contenedor-tabla {
  max-width: 800px;
  /* margin: auto; */
  justify-content: left;
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
 
  display: flex;
   border-radius: 10px;
  flex-direction: column;
}

table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  /* Cabecera fija */
  thead {
    position: sticky;
    top:0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
    padding: 10px;
  }
 
  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }



  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
.encabezado_bold{
  font-size: 14px;
}
</style>
